import React from 'react'
import SkeletonBlock from '@component/skeleton/SkeletonBlock'

interface IProps {
    className?: string
}

const MobileUserSubInformationSkeleton = ({className}: IProps) => {
    return (
        <div className={'flex items-center gap-x-[5px]'}>
            <SkeletonBlock className={'w-[80px] h-[32px]'} sizeClassName={'h-[32px]'} />
            <SkeletonBlock className={'w-[80px] h-[32px]'} sizeClassName={'h-[32px]'} />
        </div>
    )
}
export default MobileUserSubInformationSkeleton
